import { ApiError } from '@schooly/api';

export default function getIsAccessDeniedError(error?: ApiError | null) {
  return error?.reason?.toLowerCase() === 'access denied';
}
